<template>
  <div class="about_warp">
    <div class="about_banner">
      <h2 class="about_title">
        <span class="about_title_l">{{$t('about.Intelligently')}}</span>
        <span class="about_title_r">{{$t('about.Extraordinary')}}</span>
      </h2>
    </div>
    <div class="about_intro">
      <p v-html="intro"></p>
    </div>
    <div class="about_media" v-if="locale === 'cn'">
      <h3 class="about_title2">新闻媒体</h3>
      <ul class="about_newslist">
        <li v-for="item in newsList" class="about_newsitem">
          <a :href="item.URL" style="display: block; height: 100%" target="_blank">
            <img :src="item.CoverImageURl" alt="" class="newsitem_img">
            <div class="newsitem_text">
              <h2 class="newsitem_text_title">{{item.Title}}</h2>
              <div class="newsitem_text_time">
                <span>{{item.ReleaseTime[0]}}年{{item.ReleaseTime[1]}}月{{item.ReleaseTime[2]}}日</span>
                <span>{{item.Source}}</span>
              </div>
              <div class="newsitem_text_body">
                {{item.Body}}
              </div>
            </div>
          </a>
        </li>
      </ul>
      <div class="more_warp">
        <router-link to="/newslist" class="news_more">查看更多</router-link>
      </div>
    </div>
    <div class="about_progress" v-if="false">
      <h3 class="about_title2">发展历程</h3>
      <timeline></timeline>
    </div>
    <div class="about_honor" v-if="false">
      <h3 class="about_title2">我们的荣誉</h3>
      <ul class="honor_img_warp">
        <li class="honor_img">
          <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353515022.jpeg" alt="">
          <div></div>
        </li>
        <li class="honor_img">
          <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353515022.jpeg" alt="">
          <div></div>
        </li>
        <li class="honor_img">
          <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353515022.jpeg" alt="">
          <div></div>
        </li>
        <li class="honor_img">
          <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353515022.jpeg" alt="">
          <div></div>
        </li>
      </ul>

    </div>

    <div class="about_relation">
      <h3 class="about_title3">{{$t('about.Contact')}}</h3>
      <div class="about_address address_c">
        <img src="" alt="">
        <p class="address_p1">{{$t('about.china')}}</p>
        <p class="address_p2">{{$t('about.chinaAdds')}}</p>
        <p class="address_p2">{{$t('about.chinabeijing')}}</p>
      </div>
      <div class="about_address address_u">
        <img src="" alt="">
        <p class="address_p1">{{$t('about.USA')}}</p>
        <p class="address_p2">97 E Brokaw Road,Suite 210,</p>
        <p class="address_p2">San Jose,CA 95</p>
      </div>
      <div class="about_address address_s">
        <img src="" alt="">
        <p class="address_p1">{{$t('about.SINGAPORE')}}</p>
        <p class="address_p2">16 Nanyang Drive,Innovation Centre,</p>
        <p class="address_p2">Block 1 #01-109,Singapore</p>
      </div>
    </div>
    <div class="about_join">
      <a href="http://www.lagou.com/gongsi/29151.html" class="join_btn" target="_blank">{{$t('about.Join')}}</a>
    </div>
  </div>
</template>

<script>
	import fetch from '../utils/fetch';
	import bus from '../utils/bus'
  import timeline from '../components/timeline'
	export default {
		data(){
			return{
				newsList:[],
      }
    },
    created(){
      //http://123.57.150.205/
	    this._getNewsList()
    },
    mounted(){
	    bus.$emit('customEvent','about');
    },
    computed:{
      intro(){
        return this.$t('about.intro').replace(/\n/, '<br>')
      },
	    locale(){
		    return this.$i18n.locale
	    }
    },
    methods:{
      _getNewsList(){
	      fetch({
		      url: '/media/reports',
		      method: 'get',
		      params:{pagenum:1,pagesize:3}
        }).then(res => {
		      //console.log(res);
		      this.newsList = res.data.Reports
		      this.newsList.map(item => {
			      item.ReleaseTime = item.ReleaseTime.split('-');
			      return item;
		      })
	      })
      }
    },
    components:{
	    timeline
    }
  }
</script>

<style>
  @media screen and (min-width: 768px){
    .about_warp{

    }
    /*banner图*/
    .about_banner{
      background: url("http://bu.dressplus.cn/cdn/media/reports/img/15305235322871.jpeg") no-repeat center;
      background-position-y: 26%;
      height: 520px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .about_title{
      color: #fff;
      font-size: 32px;
    }
    .about_title_l{
      margin-right: 35px;
    }
    .about_title_r{
      margin-left: 35px;
    }
    /*简介*/
    .about_intro{
      width: 70%;
      margin: 0 auto;
    }
    .about_intro>p{
      font-size: 18px;
      box-sizing: border-box;
      padding: 50px 57px;
      line-height: 40px;
      color: #474a4d;
    }
    .about_title2{
      text-align: center;
      font-size: 28px;
      margin: 30px 0 25px;
    }
    /*媒体报道*/
    .about_newslist{
      margin: 0 auto;
      width: 70%;
      display: flex;
      justify-content:center;
    }
    .about_newsitem{
      width: 29%;
      min-width: 340px;
      height: 594px;
      margin: 0 10px;
    }
    .newsitem_img{
      width: 100%;
      height: 45%;
      vertical-align: middle;
    }
    .newsitem_text{
      height: 45%;
      box-sizing: border-box;
      border: 1px #92979e solid;
      border-top: none;
      padding: 20px 10px;
    }
    .newsitem_text_title{
      font-size: 24px;
      line-height: 30px;
      color: #000;
    }
    .newsitem_text_title:hover{
      color: #008cee;
    }
    .newsitem_text_time{
      font-size: 14px;
      color: #92979e;
      padding: 20px 0 10px;
    }
    .newsitem_text_body{
      font-size: 15px;
      color: #474a4d;
      padding-top: 10px;
      line-height: 25px;
    }
    .more_warp{
      text-align: center;
      margin: 30px 0;
    }
    .news_more{
      display: inline-block;
      background: rgb(0,140,238);
      padding: 10px 15px;
    }
    /*联系我们*/
    .about_relation{
      background: url("http://bu.dressplus.cn/cdn/media/reports/img/15305235327632.jpeg") no-repeat;
      height: 680px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }
    .about_title3{
      font-size: 28px;
      color: #fff;
      position: absolute;
      top: 100px;

    }
    .about_address{
      width: 400px;
      height: 218px;
      text-align: center;
    }
    .address_p1{
      font-size: 24px;
      color: #fff;
      margin: 10px 0;
    }
    .address_p2{
      font-size: 16px;
      color: #bcdef5;
      margin: 5px 0;
    }
    .address_c{
      background: #006fbd;
    }
    .address_u{
      background: #0079ce;
    }
    .address_s{
      background: #0083de;
    }
    /*发展历程*/
    .about_progress{
      height: 500px;
      background: rgb(245,245,247);
    }
    /*荣誉*/
    .about_honor{
      width: 70%;
      margin: 0 auto;
    }
    .honor_img_warp{
      overflow: hidden;
    }
    .honor_img{
      width: 23%;
      float: left;
      margin-right: 2%;
    }
    .honor_img img{
      width: 100%;
      vertical-align: middle;
    }
    /*加入我们*/
    .about_join{
      height: 260px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url("http://bu.dressplus.cn/cdn/media/reports/img/15305235329743.png") no-repeat center;
    }
    .join_btn{
      background: rgb(0,140,238);
      padding: 10px 30px;
    }
  }

  @media screen and (max-width: 767px){
    .about_warp{

    }
    /*banner图*/
    .about_banner{
      background: url("http://bu.dressplus.cn/cdn/media/reports/img/15305235322871.jpeg") no-repeat center;
      background-position-y: 37%;
      height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .about_title{
      color: #fff;
      font-size: 0.85rem;
    }
    .about_title_l{
      margin-right: 35px;
    }
    .about_title_r{
      margin-left: 35px;
    }
    /*简介*/
    .about_intro{
      width: 90%;
      margin: 0 auto;
    }
    .about_intro>p{
      font-size: 0.32rem;
      box-sizing: border-box;
      padding: 30px 20px;
      line-height: 0.66rem;
      color: #474a4d;
    }
    .about_title2{
      text-align: center;
      font-size: 28px;
      margin: 30px 0 25px;
    }
    /*媒体报道*/
    .about_newslist{
      margin: 0 auto;
    }
    .about_newsitem{
      width: 70%;
      height: 400px;
      margin: 5px auto;
    }
    .newsitem_img{
      width: 100%;
      height: 45%;
      vertical-align: middle;
    }
    .newsitem_text{
      height: 45%;
      box-sizing: border-box;
      border: 1px #92979e solid;
      border-top: none;
      padding: 20px 10px;
    }
    .newsitem_text_title{
      font-size: 24px;
      line-height: 30px;
      color: #000;
    }
    .newsitem_text_title:hover{
      color: #008cee;
    }
    .newsitem_text_time{
      font-size: 16px;
      color: #92979e;
      padding: 10px 0;
    }
    .newsitem_text_body{
      font-size: 16px;
      color: #474a4d;
      padding-top: 10px;
      display: none;
    }
    .more_warp{
      text-align: center;
      margin: 30px 0;
    }
    .news_more{
      display: inline-block;
      background: rgb(0,140,238);
      padding: 10px 15px;
      font-size: 0.37rem;
      display: none;
    }
    /*联系我们*/
    .about_relation{
      background: url("http://bu.dressplus.cn/cdn/media/reports/img/15305235327632.jpeg") no-repeat;
      height: 480px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }
    .about_title3{
      font-size: 28px;
      color: #fff;
      position: absolute;
      top: 50px;

    }
    .about_address{
      width: 400px;
      height: 218px;
      text-align: center;
    }
    .address_p1{
      font-size: 16px;
      color: #fff;
      margin: 10px 0;
    }
    .address_p2{
      font-size: 12px;
      color: #bcdef5;
      margin: 5px 0;
    }
    .address_c{
      background: #006fbd;
    }
    .address_u{
      background: #0079ce;
    }
    .address_s{
      background: #0083de;
    }
    /*发展历程*/
    .about_progress{
      height: 500px;
      background: rgb(245,245,247);
    }
    /*荣誉*/
    .about_honor{
      width: 70%;
      margin: 0 auto;
    }
    .honor_img_warp{
      overflow: hidden;
    }
    .honor_img{
      width: 23%;
      float: left;
      margin-right: 2%;
    }
    .honor_img img{
      width: 100%;
      vertical-align: middle;
    }
    /*加入我们*/
    .about_join{
      height: 260px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url("http://bu.dressplus.cn/cdn/media/reports/img/15305235329743.png") no-repeat center;
    }
    .join_btn{
      font-size: 0.37rem;
      background: rgb(0,140,238);
      padding: 10px 30px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/about2.vue